import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { NimAuthApiClientService } from './auth-api-client.service';
import { NimWebshareAuthFormComponent } from './auth-form.component';
import {FormsModule} from "@angular/forms";
import {HttpClientModule} from "@angular/common/http";

@NgModule({
  imports: [ CommonModule, MatMenuModule, FormsModule, HttpClientModule],
  exports: [ NimWebshareAuthFormComponent ],
  declarations: [ NimWebshareAuthFormComponent ],
  providers: [ NimAuthApiClientService ],
})
export class NimWebshareAuthFormModule {}
